import { render, staticRenderFns } from "./BlinkBackgroundComponent.vue?vue&type=template&id=a959cb0c&scoped=true&"
import script from "./BlinkBackgroundComponent.vue?vue&type=script&lang=js&"
export * from "./BlinkBackgroundComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlinkBackgroundComponent.vue?vue&type=style&index=0&id=a959cb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a959cb0c",
  null
  
)

export default component.exports